import { Card, Button, ListGroup, Badge } from 'react-bootstrap';
import { BoxSeam, Droplet, BarChartLine, People, Gear } from 'react-bootstrap-icons';

const ICONS = {
    Objetos: BoxSeam,
    Consumibles: Droplet,
    Reportes: BarChartLine,
    Usuarios: People,
    Configuraciones: Gear,
};

function HomeRouteCard({ element }) {
    const hasFeatures = Array.isArray(element.features) && element.features.length > 0;
    const PrimaryIcon = ICONS[element.title] || BoxSeam;

    const primary = hasFeatures ? element.features[0] : null;
    const secondary = hasFeatures ? element.features.slice(1) : [];

    return (
        <Card className="route-card border-0 shadow-sm position-relative">
            <Card.Body className="p-3">
                <div className="d-flex align-items-start justify-content-between">
                    <div className="d-flex gap-2 align-items-center">
                        <div className="icon-chip">
                            <PrimaryIcon size={18} />
                        </div>
                        <div>
                            <Card.Title className="mb-1">{element.title}</Card.Title>
                            <div className="text-muted" style={{ fontSize: 12 }}>
                                {element.description || 'Accesos rápidos del módulo'}
                            </div>
                        </div>
                    </div>

                    {hasFeatures ? (
                        <Badge bg="secondary" pill>
                            {element.features.length}
                        </Badge>
                    ) : null}
                </div>

                {primary ? (
                    <div className="mt-3">
                        <Button
                            href={primary.url}
                            className="w-100"
                            variant="primary"
                        >
                            {primary.name}
                        </Button>
                        {primary.description ? (
                            <div className="text-muted mt-1" style={{ fontSize: 12 }}>
                                {primary.description}
                            </div>
                        ) : null}
                    </div>
                ) : null}

                {secondary.length ? (
                    <ListGroup className="list-group-flush mt-3">
                        {secondary.map((child) => (
                            <ListGroup.Item
                                key={`feat-${element.title}-${child.url || child.name}`}
                                className="px-0"
                            >
                                <a className="text-decoration-none" href={child.url}>
                                    {child.name}
                                </a>
                                {child.description ? (
                                    <div className="text-muted" style={{ fontSize: 12 }}>
                                        {child.description}
                                    </div>
                                ) : null}
                            </ListGroup.Item>
                        ))}
                    </ListGroup>
                ) : null}

                <div className="mt-3 text-muted" style={{ fontSize: 12 }}>
                    {element.mainLabel}
                </div>
            </Card.Body>

            {element.mainUrl ? (
                <a
                    href={element.mainUrl}
                    className="stretched-link"
                    aria-label={`Abrir ${element.title}`}
                />
            ) : null}
            <style>{`
            .route-card { transition: transform .12s ease, box-shadow .12s ease; }
            .route-card:hover { transform: translateY(-3px); box-shadow: 0 .75rem 1.5rem rgba(0,0,0,.08) !important; }
            .icon-chip {
                width: 34px; height: 34px;
                border-radius: 10px;
                display: grid; place-items: center;
                background: rgba(13,110,253,.10);
                color: #0d6efd;
            }
            `}</style>
        </Card>
    );
}

export default HomeRouteCard;